const formStyles = {
	width: '100%',
	payframeHeightScaling: 'dynamic',
	formLayout: '1',
	border: '0',
	borderBottom: '2px solid #858585',
	borderRadius: '0',
	backgroundColor: '#f8f3e8',
	fontSize: '18px',
	// fontSrc: '', // TODO: Can we load a font file externally, might need to happen when we have a staging/live url?
	padding: '12px 0',
	cardTypeDisplay: 'none',
	cardImageAlignment: 'none',
	fieldAutoTabbing: 'disabled',
	marginBottom: '30px',
	display: 'block',
	fieldErrorStyle: {
		backgroundColor: '#f8f3e8',
		color: '#cd2337',
		borderColor: '#cd2337',
	},
	fieldFocusStyle: {
		borderColor: '#e9610c',
	},
	fieldLabelStyle: {
		display: 'block',
		fontSize: '14px',
		color: '#5c5c5c',
		letterSpacing: '0.5px',
	},
	fieldLabelText: {
		name: 'Cardholder Name *',
		number: 'Card Number *',
		expiry: 'Expiry (MM/YY) *',
		cvv: 'CVV *',
	},
	errorLabelStyle: {
		color: '#cd2337',
		fontSize: '14px',
	},
	placeholderStyle: {
		display: 'none',
	},
};

export const initialisePayframe = (
	uuid,
	apiKey,
	apiBase,
	apiBaseUrl,
	addCard = false
) => {
	const method = addCard ? 'addCard' : 'getPayframeToken';

	// eslint-disable-next-line
	return new payframe(
		uuid,
		apiKey,
		'mw-card-fields', // ID of container div
		apiBaseUrl,
		apiBase,
		formStyles,
		'visa,mastercard,amex',
		method
	);
};
